export default __webpack_public_path__ + "a11aad598824906319d90f3a3c8562e8.png";